import React, { useState } from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { CreateReadingModal } from "@features/workspace-readings/components/CreateReadingModal";
import { useAppSelector } from "@store/hooks";
import type { RootState } from "@store/index";
import { TOUR } from "@features/onboarding/tourTargets";

export const CreateReadingButton: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const workspaceId = useAppSelector((state: RootState) => state.workspace.workspace_id);

  if (!workspaceId) {
    return null;
  }

  return (
    <>
      <Button
        data-tour={TOUR.addReading}
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => setModalOpen(true)}
      >
        Create Reading
      </Button>
      <CreateReadingModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        workspaceId={workspaceId}
      />
    </>
  );
};
